import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { MatterChecklistsState } from '@state/matter/checklist';
import { ICON } from '@core/util/icon';
import { TestHooks } from './checklist-nav-bar.hooks';

@Component({
	selector: 'app-checklist-nav-bar',
	templateUrl: './checklist-nav-bar.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ChecklistNavBarComponent {
	public showChecklistDropdown = false;
	public ICON = ICON;
	public testHooks = TestHooks;

	@Select(MatterChecklistsState.getChecklistCompletePercentage)
	completePercentage$: Observable<number>;
}
